export default "__VITE_ASSET__CWdSbsAG__"